module.exports = __webpack_public_path__ + "static/media/arrow-right.inline.c2cc08be.svg";